<script setup lang="ts">
/**
 * Module: web/src/App.vue
 * Author: Salvo Praxis (w/ AI pair programming partner Claude Code by Anthropic)
 * Version: 1.0.0
 * Date: 2026-07-08
 *
 * Root component -- picks the layout per route meta:
 *   'app'  (default) -> AppShell (top bar + cap-filtered nav)
 *   'bare'           -> BareLayout (login / PIN / reset / quick shell)
 */
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppShell from '@/layouts/AppShell.vue';
import BareLayout from '@/layouts/BareLayout.vue';

const route = useRoute();
const layout = computed(() => (route.meta.layout === 'bare' ? BareLayout : AppShell));
</script>

<template>
  <component :is="layout">
    <RouterView />
  </component>
</template>
